import { useCountUpOnView } from "@hooks/V2/useCountUpOnView"
import useSiteTrustedValues from "@hooks/V2/useSiteTrustedValues"
import interpolateTemplate from "@utils/V2/interpolateTemplate"

export type TrustedValueKey = "trustedByNumBusinesses" | "trustedByNumUsers"

export const TRUSTED_BY_BUSINESSES_TOKEN = "{{trustedByNumBusinesses}}"

const TRUSTED_COUNT_LOCALE = "en-ZA"

export const formatTrustedCount = (value: number, suffix: string): string =>
  `${value.toLocaleString(TRUSTED_COUNT_LOCALE)}${suffix}`

interface UseTrustedByTextArgs {
  template: string
  valueKey: TrustedValueKey
  isAnimated?: boolean
}

const useTrustedByText = ({
  template,
  valueKey,
  isAnimated = false,
}: UseTrustedByTextArgs) => {
  const trustedValues = useSiteTrustedValues()
  const { value: targetValue, suffix } = trustedValues[valueKey]

  const { intersectionElementRef, displayedValue } = useCountUpOnView(
    targetValue ?? 0
  )

  const highlightedText = formatTrustedCount(
    isAnimated ? displayedValue : (targetValue ?? 0),
    suffix
  )
  const text = interpolateTemplate(template, { [valueKey]: highlightedText })

  return {
    text,
    highlightedText,
    intersectionElementRef,
    isReady: targetValue !== undefined,
  }
}

export default useTrustedByText
